import {Component} from '@angular/core';

@Component({
  selector: 'pt-form-container',
  template: `
    <div class="pt-form-container">
      <div class="form-container">
        <ng-content select='[form]'></ng-content>
      </div>
      <div class="action-container">
        <ng-content select='[action]'></ng-content>
      </div>
    </div>
  `,
  styles: [`
    .pt-form-container {
      position: relative;
      width: 100%;
      height: calc(100% - 155px);
      overflow: hidden;
    }

    .pt-form-container .form-container {
      position: relative;
      width: 100%;
      height: calc(100% - 100px);
      overflow-y: auto;
    }

    .pt-form-container .action-container {
      position: relative;
      width: 100%;
      height: 100px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

  `]
})
export class FormContainerComponent {

}
